/** Network-level human review for Run tab / execute API (light path). Email ingress is unchanged. */
export const NETWORK_HUMAN_REVIEW_OPTIONS = [
  {
    value: 'AUTONOMOUS',
    label: 'Autonomous',
    hint: 'Run and API executions complete in one shot. Agent draft mode and confidence do not pause for a supervisor.'
  },
  {
    value: 'AGENT_POLICY',
    label: 'Per-agent human review',
    hint: 'Each agent step can pause for the supervisor (same rules as email: draft-only, custom modes, confidence threshold). Multi-agent flows may require multiple approvals.'
  }
];

export const DEFAULT_NETWORK_HUMAN_REVIEW_MODE = 'AUTONOMOUS';

export function normalizeNetworkHumanReviewMode(value) {
  const s = String(value || '').toUpperCase().trim();
  if (s === 'AGENT_POLICY') return 'AGENT_POLICY';
  return 'AUTONOMOUS';
}
